import React, {useEffect, useState} from 'react';
import axios from "axios";
import opsToast from "../ops-library/ops-toast";
import {useNavigate, useParams} from "react-router-dom";
import grapesjs from 'grapesjs'
import 'grapesjs/dist/css/grapes.min.css'
import 'grapesjs/dist/grapes.min.js'
import plugin from 'grapesjs-preset-newsletter';
// import 'grapesjs-preset-webpage/dist/css/grapesjs-preset-newsletter.css'
// import 'grapesjs-preset-webpage/dist/grapesjs-preset-newsletter.min.js'
import OpsBtn from "../ops-library/ops-btn";
import AppContainer from "./AppContainer";
import OpsText from "../ops-library/ops-text";
import {ACCESS_TOKEN_KEY} from "../constants/constants";
import articleContentReplacator from "../functions/articleContentReplacator";

const PageBuilder = () => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [loading, setLoading] = useState(false);
    const [editor, setEditor] = useState(null);
    const {subpageID, articleID} = useParams();
    const navigate = useNavigate();

    function exportContent() {
        return editor.runCommand('gjs-get-inlined-html');
    }

    function handleSaveContent() {
        setLoading(true)
        const htmlContent = exportContent();
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles/${articleID}`,
            data: {
                content: articleContentReplacator(htmlContent, [{
                    old: "color: black",
                    new: "color: white"
                }])
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((response) => {
                opsToast(response.data.message, "success");
                setLoading(false)
            })
            .catch((error) => {
                console.log(error)
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                setLoading(false)
            });
    }


    async function getContent() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles/article_id=${articleID}`,
        };

        await axios(configuration)
            .then(async (result) => {
                const grapesEditor = await grapesjs.init({
                    container: '#gjs',
                    height: '90vh',
                    width: '100vw',
                    plugins: [plugin],
                    storageManager: {
                        id: 'gjs-',
                        type: 'remote',
                        stepsBeforeSave: 3,
                        contentTypeJson: true,
                        storeComponents: true,
                        storeStyles: true,
                        storeHtml: true,
                        storeCss: true,
                        autosave: true,
                    },
                    projectData: {
                        pages: [
                            {
                                component: result.data.content.content
                            }
                        ]
                    },
                    deviceManager: {
                        devices:
                            [
                                {
                                    id: 'desktop',
                                    name: 'Desktop',
                                    width: '',
                                },
                                {
                                    id: 'tablet',
                                    name: 'Tablet',
                                    width: '768px',
                                    widthMedia: '992px',
                                },
                                {
                                    id: 'mobilePortrait',
                                    name: 'Mobile portrait',
                                    width: '320px',
                                    widthMedia: '575px',
                                },
                            ]
                    },
                    pluginsOpts: {
                        [plugin]: {
                            blocks: ['sect100', 'sect50', 'sect30', 'sect37', 'button', 'divider', 'text', 'text-sect', 'image', 'quote', 'grid-items', 'list-items'],
                        }
                    },
                    canvas: {
                        styles: [`
                            body {
                                background-color: #444 !important;  /* Sivé plátno */
                                color: #fff !important;  /* Biele písmo */
                                }
                            `]
                    }
                })
                // Ak chceme upraviť aj predvolené štýly pre nový obsah
                grapesEditor.CssComposer.addRules([
                    {
                        selectors: ['body'],
                        style: {
                            'background-color': '#444',
                            'color': '#fff'
                        }
                    }
                ]);
                setEditor(grapesEditor)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    return (
        <AppContainer
            showFooter={false}
            showNavbar={false}
            content={
                <div className="window-all-page-container fa-flex-col justify-content-between">
                    <div className="desktop-row-phone-col justify-content-between align-items-center">
                        <OpsText type="title px-2" weight={600}
                                 content={subpageID !== undefined ? "Úprava obsahu podstránky" : "Úprava obsahu článku"}/>
                        {editor === null &&
                            <OpsBtn
                                text={!loading ? "Načítať obsah" : "načítávam obsah..."}
                                size="md m-2"
                                action={async () => {
                                    setLoading(true)
                                    await getContent()
                                    setLoading(false)
                                }}
                            />
                        }
                        <div className="fa-flex-row mt-3 m-2 align-items-center justify-content-start gap-2">
                            <OpsBtn
                                variant="secondary"
                                size="md px-5"
                                text="Vrátiť sa späť"
                                action={() => navigate(-1)}
                            />
                            <OpsBtn
                                variant="primary"
                                size="md px-5"
                                text={loading && editor !== null ? "ukladám..." : "Uložiť zmeny"}
                                action={() => handleSaveContent()}
                            />
                        </div>
                    </div>
                    <div id="gjs"></div>
                </div>
            }
        />
    );
};

export default PageBuilder;